import React from "react";
// import PropTypes from "prop-types";

// import Logo from '../../assets/img/ak-mob3.svg';
import Logo from '../../assets/img/ak-mob3.svg';


import './LogoUser.css';


const LogoUser = (props) => {

    return (
        <div className='akinda-logo'>
            <img className='img-akindalogo' src={Logo} alt='AkindaLogo'/>
        </div>
    );
}

export default LogoUser;


// WEBPACK FOOTER //
// ./src/layouts/Users/LogoUser.jsx